import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import axios from 'axios';
import i18n from "@/helpers/i18n";

export interface Standman {
  _id: string,
  contacts: {},
  name: {
    first: string,
    last: string,
    middle: string
  },
  position: string,
  fio: {},
  promo: [],
  description: string,
}

export interface State {
  standmans:Standman[],
  loading:boolean
}

const defaultState: State = {
  standmans:[],
  loading:false
};

const getters = {
  loading: (state: State) => state.loading,
  standmans: (state: State) => state.standmans,
}

const mutations: MutationTree<State> = {
  setStandmans(state: State, payload: Standman[]) {
    state.standmans = payload.map((element:any)=>{
      if(element.name.middle == 'null') element.name.middle = ''
      return {...element, fio:element.name.first + ' '+ element.name.middle + ' ' +element.name.last }
    })
  },
  setStandman(state: State, payload: Standman) {
    payload.fio = payload.name.first + ' ' + payload.name.middle + ' ' + payload.name.last
    state.standmans = state.standmans.map((el: Standman) => {
      if (el._id === payload._id) return payload
      return el
    })
  },
  deleteStandman(state: State, payload: string) {
    if(state.standmans){
      const arr:Standman[] = state.standmans.filter((v:any) => v._id != payload)
      state.standmans = arr
    }
  },
  addStandman(state: State, payload: Standman) {
    payload.fio = payload.name.first + ' '+ payload.name.middle + ' ' +payload.name.last
    state.standmans.push(payload)
  },
  setLoadStatus(state: State, payload: boolean) {
    state.loading = payload
  }
}

const actions: ActionTree<State, RootState> = {
  async loadStandmansFromServer({commit, state},payload:string) {
    commit('setLoadStatus', true)
    try {
      const {data} = await axios.get('/v4/company/'+payload+'/stand-men?expand=platform')
      if(data.error){
        throw (data.error)
      }
      commit('setStandmans', data)
      commit('setLoadStatus', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      commit('setLoadStatus', false)
    }
  },
  async editStandmanFromServer({commit, state},payload:any){
    commit('setLoadStatus', true)
    const id = payload._id
    const params = {
        name: {
          first: payload.name.first,
          last: payload.name.last
        },
        position: payload.position,
        description: payload.description,
    }

    try {
      const {data} = await axios.patch('v4/badge/' + id, params)
      commit('setStandman', data.data)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: [i18n.t('company_standmans.notifications.save_success')]
      })
      commit('setLoadStatus', false)
      return true
    }catch (e) {
      console.log('error', e)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
      return false
    }
  },
  async deleteStandmanFromServer({commit, state},payload:string) {
    try {
      const {data} = await axios.delete('/v4/show/company/stand-men/' + payload)
      if(data[0].data.status === 'ok'){
        commit('deleteStandman', payload)
        this.commit('alerts/setAlert', {
          show: true,
          messages: [i18n.t('company_standmans.notifications.standman_deleted')]
        })
      } else {
        throw(data)
      }
      return true
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      return false
    }
  },
  async addStandmanFromServer({commit, state},payload:any) {
    const params = {
      data: {
        name: payload.name
      }
    }
    try {
      const data = await axios.post('/v4/show/company/' + payload.companyId + '/stand-men', params)
      commit('addStandman', data.data.data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('company_standmans.notifications.standman_added')]
      })
      return true
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      return false
    }
  },
  async saveContactFromServer({commit, state},payload:any){
    const id = payload._id
    const params = {
        contacts: payload.contacts
    }
    try {
      const {data} = await axios.patch('v4/badge/' + id, params)
      payload = {...payload, contacts: data.data.contacts}
      commit('setStandman', payload)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: [i18n.t('company_standmans.notifications.save_success')]
      })
      commit('setLoadStatus', false)
      return payload
    }catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      commit('setLoadStatus', false)
      return false
    }
  },
  async savePromoFromServer({commit, state},payload:any){
    const id = payload._id
    const params = {
        promo: payload.promo
    }
    try {
      const {data} = await axios.patch('v4/badge/' + id, params)
      payload = {...payload, promo: data.data.promo}
      commit('setStandman', payload)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: [i18n.t('company_standmans.notifications.save_success')]
      })
      commit('setLoadStatus', false)
      return true
    }catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: ['111']
      })
      commit('setLoadStatus', false)
      return false
    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
